import React, { useEffect, useRef } from "react";
import { ADSENSE_CLIENT } from "../lib/adsense";

// Slot IDs come from env so nothing is hardcoded. Create ad units in your
// AdSense dashboard, then add the IDs to frontend/.env.
const SLOT_ENV = {
  leaderboard: process.env.REACT_APP_ADSENSE_SLOT_LEADERBOARD || "",
  rectangle: process.env.REACT_APP_ADSENSE_SLOT_RECTANGLE || "",
  inContent: process.env.REACT_APP_ADSENSE_SLOT_INCONTENT || "",
  sidebar: process.env.REACT_APP_ADSENSE_SLOT_RECTANGLE || "",
};

const SIZES = {
  leaderboard: "min-h-[90px] md:min-h-[120px]",
  sidebar: "min-h-[280px] w-full",
  inContent: "min-h-[110px] w-full",
  rectangle: "min-h-[250px] w-full",
};

export const AdSlot = ({ format = "leaderboard", className = "", testid, slot }) => {
  const adSlot = slot || SLOT_ENV[format];
  const live = Boolean(ADSENSE_CLIENT && adSlot);
  const autoAdsMode = Boolean(ADSENSE_CLIENT && !adSlot);
  const insRef = useRef(null);

  useEffect(() => {
    if (!live) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // AdSense not ready yet — non-blocking
    }
  }, [live]);

  // Auto Ads mode: Google auto-places ads across the page, so we render
  // nothing here to avoid empty boxes next to auto-placed units.
  if (autoAdsMode) return null;

  if (live) {
    return (
      <div data-testid={testid || `ad-slot-${format}`} className={`w-full ${SIZES[format]} ${className}`}>
        <ins
          ref={insRef}
          className="adsbygoogle"
          style={{ display: "block", width: "100%", height: "100%" }}
          data-ad-client={ADSENSE_CLIENT}
          data-ad-slot={adSlot}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    );
  }

  // Placeholder until AdSense IDs are configured.
  return (
    <div
      data-testid={testid || `ad-slot-${format}`}
      aria-hidden="true"
      className={`relative w-full border-2 border-dashed border-ink bg-[#EBEBE5] flex flex-col items-center justify-center overflow-hidden ${SIZES[format]} ${className}`}
    >
      <span className="absolute top-0 left-0 bg-ink text-paper font-mono text-[10px] uppercase px-2 py-1 tracking-[0.2em]">
        Advertisement
      </span>
      <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink/40">
        Ad space · {format}
      </span>
    </div>
  );
};
